import React, { Component } from 'react';
import Container from '../../../components/Container';
import Iframe from '../../../components/Iframe';
import { ENV } from '../../../services/utils';

export default class AppList extends Component {
  render() {
    const src =
      ENV === 'production'
        ? '//manage.xiaoyuanhao.com/manage/page/board/appTemplate/list.html'
        : '//aly-test.api.xiaoyuanhao.com/sys-manage-test/manage/page/board/appTemplate/list.html';
    const IframeDom = Iframe({ src });

    return (
      <Container breStates defaultPadding>
        <IframeDom />
      </Container>
    );
  }
}
